import cn from "classnames";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import styles from "./SectionCard.module.scss";

interface SectionCardProps {
  title?: string;
  icon?: ReactNode;
  accentColor?: string;
  subtitle?: string;
  action?: ReactNode;
  className?: string;
  children: ReactNode;
}

const SectionCard = ({
  title,
  icon,
  accentColor = "#FB3973",
  subtitle,
  action,
  className,
  children
}: SectionCardProps) => {
  const { t } = useTranslation();

  return (
    <section className={cn(styles.card, className)}>
      {(title || action) && (
        <div className={styles.card__header}>
          <div className={styles.card__titleWrap}>
            {title && (
              <>
                {icon ? (
                  <span
                    className={styles.card__icon}
                    style={{
                      backgroundColor: `${accentColor}14`,
                      color: accentColor
                    }}
                  >
                    {icon}
                  </span>
                ) : (
                  <span
                    className={styles.card__dot}
                    style={{ backgroundColor: accentColor }}
                  />
                )}
                <span className={styles.card__title}>{t(title)}</span>
              </>
            )}
          </div>

          {action}
        </div>
      )}

      {subtitle && <p className={styles.card__subtitle}>{t(subtitle)}</p>}

      {children}
    </section>
  );
};

export default SectionCard;
